<template>
  <div :class="$style.container">
    <div
      ref="scrollbar"
      v-scrollbar="{
        id: 'scrollbar-datepicker',
      }"
      :class="$style.content"
    >
      <div
        v-for="(month, index) in months"
        :key="index"
        :class="$style.palette"
      >
        <datepicker-palette
          ref="month"
          :min="min"
          :max="max"
          :range="range"
          :value="value"
          :month="month"
          :hover-day="hoverDay"
          :first-day-offset="firstDayOffset"
          is-mobile
          @input="onInputValue"
          @hover:day="hoverDay = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import { boundDate, sortRange, transformDateValue } from 'lib/utils/dateRange';

import { ScrollbarDirective } from 'molecules/scrollbar';
import DatepickerPalette from 'molecules/datetime/DatepickerPalette';

export default {
  name: 'DatepickerCalendar',
  components: {
    DatepickerPalette,
  },
  directives: {
    'scrollbar': ScrollbarDirective,
  },
  props: {
    value: { // { from: moment, to: moment } | moment
      type: Object,
      default: null,
    },
    min: {
      type: Object,
      default: () => moment('2017-01-01'),
    },
    max: {
      type: Object,
      default: () => moment(),
    },
    firstDayOffset: { // 0 - первый день понедельник, 1 - воскресенье
      type: Number,
      default: 0,
    },
    range: Boolean,
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.scrollbar?.scroll({
        left: 0,
        top: this.$refs.scrollbar?.scrollHeight ?? 0,
      });

      this.updateScroll();
    });
  },

  data() {
    return {
      hoverDay: null,
      /*
       * реализует механизм, при котором мы не вызываем прокрутку календаря
       * если мы в текущем компонента выбрали дату
       * то есть при изменениях снаружи календарь автоматически прокручивается до даты
       * но прокрутка не мешает работать в календаре
       */
      isBlockedScroll: false,
    };
  },
  computed: {
    months() {
      const monthCount = this.max.diff(this.min, 'M');

      return Array.from({ length: monthCount + 1 })
        .map((_, index) => this.min.clone().add(index, 'month').startOf('month'));
    },
  },
  watch: {
    value(val) {
      this.updateScroll();

      this.$emit('input', val);
    },
  },
  methods: {
    onInputValue(value) {
      this.isBlockedScroll = true;

      if (this.range) {
        this.$emit('input', sortRange(value));
      } else {
        this.$emit('input', boundDate(value, [this.min, this.max]));
      }
    },
    updateScroll() {
      if (this.isBlockedScroll) {
        this.isBlockedScroll = false;
        return;
      }

      this.$nextTick(() => {
        const currentValue = transformDateValue(this.value, false);

        const monthList = this.$refs.month || [];
        const currentMonth = currentValue?.clone()
          .startOf('month');
        for (let i = 0; i < monthList.length; i++) {
          const monthCalendar = monthList[i];

          const isCurrentMonth = currentMonth.format('MM.YYYY') === monthCalendar.currentMonth.format('MM.YYYY');
          if (isCurrentMonth) {
            setTimeout(() => {
              monthCalendar.$el.scrollIntoView();
            }, 100);
            break;
          }
        }
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    --row-height: 36px
    --row-border-weight: 2px
    --daypicker-bg-color: #131212

    .content
      padding: 20px 10px

    .palette
      &:not(:last-child)
        margin-bottom: 16px

  .content
    display: flex
    flex-direction: column
    background: var(--daypicker-bg-color)
    padding: 10px
    border-radius: 10px

  .scrollbar
    scrollbar-width: none

    &::-webkit-scrollbar
      display: none
</style>
